import React from 'react'

const Footer = (props) => (
    <footer id="footer">
        <div className="inner">
            <ul className="icons">
                <li><a href="https://github.com/baumli" className="icon alt fab fa-github"><span className="label">GitHub</span></a></li>
                <li><a href="https://www.linkedin.com/in/jeremy-baumli/" className="icon alt fab fa-linkedin"><span className="label">LinkedIn</span></a></li>
            </ul>
            <ul className="copyright">
                <li>&copy; 2020</li>
            </ul>
        </div>
    </footer>
)

export default Footer
